/**
 * TanStack Query keys for the gift sets storefront grid (paginated listing).
 */
export const giftSetGridKeys = {
  all: ["gift-sets-grid"] as const,
  list: (locale: string, page: number) => [...giftSetGridKeys.all, locale, page] as const,
};
